import {
	ILinkedInEducation,
	ILinkedInExperience,
	ILinkedInLocationData,
	ILinkedInProfileData,
	ISLinkedInEducation,
	ISLinkedInExperience,
	ISLinkedInExperienceMap,
	ISLinkedInLocationData,
	ISLinkedInProfileData,
} from '@/shared/services/submissions/submissions.types';

export function getStructuredLinkedInEducation(obj: ILinkedInEducation): ISLinkedInEducation {
	return {
		startDate: obj.start_date,
		endDate: obj.end_date,
		schoolName: obj.school_name,
		degreeName: obj.degree_name,
		fieldOfStudy: obj.field_of_study,
		image: obj.image,
	};
}

export function getStructuredLinkedInLocationData(
	obj: ILinkedInLocationData
): ISLinkedInLocationData {
	return {
		city: obj.city,
		country: obj.country,
		default: obj.default,
		state: obj.state,
	};
}

export function getStructuredLinkedInExperience(obj: ILinkedInExperience): ISLinkedInExperience {
	return {
		company: obj.company,
		title: obj.title,
		location: obj.location,
		startDate: obj.start_date,
		endDate: obj.end_date,
		image: obj.image,
		employmentType: obj.employment_type,
		description: obj.description,
		totalMonths: obj.total_months,
	};
}

function getSenderExperienceMap(experienceArr: ISLinkedInExperience[]) {
	const experienceMap: ISLinkedInExperienceMap = {};

	experienceArr.map((experience) => {
		const key = experience.company;
		if (experienceMap[key]) {
			const obj = experienceMap[key];
			experienceMap[key] = {
				...obj,
				allExperiences: [...obj.allExperiences, experience],
				showTimePeriod: obj.showTimePeriod ? !!experience.totalMonths : false,
			};
		} else {
			experienceMap[key] = {
				allExperiences: [experience],
				showTimePeriod: !!experience.totalMonths,
			};
		}
	});

	return experienceMap;
}

export function getExperienceCompanyOrder(experienceArr: ILinkedInExperience[]) {
	const experienceCompanyOrderSet = new Set<string>();

	experienceArr.map((experience) => {
		experienceCompanyOrderSet.add(experience.company);
	});

	return Array.from(experienceCompanyOrderSet);
}
export function getStructuredLinkedInProfileData(obj: ILinkedInProfileData): ISLinkedInProfileData {
	return {
		linkedInURL: obj.linkedin_url,
		firstName: obj.first_name,
		lastName: obj.last_name,
		image: obj.image,
		headline: obj.headline,
		summary: obj.summary,
		education: obj.education?.map(getStructuredLinkedInEducation) ?? [],
		experience: getSenderExperienceMap(obj.experience?.map(getStructuredLinkedInExperience) ?? []),
		experienceCompanyOrder: getExperienceCompanyOrder(obj.experience ?? []),
		location: getStructuredLinkedInLocationData(obj.location),
		isCompanyProfile: obj.is_company_profile ?? false,
	};
}
